import { keys } from "./Keys";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { ISummaryObjectsDTO, ISummarySearchDTO } from "../../services/setpoint-administration-service/Models";
import SetpointAdministrationDataService from "../../services/setpoint-administration-service/SetpointAdministrationService";
import { useQuery } from "react-query";

export type UseObjectsWithoutSetpointsDataParams = {
    groupID: number,
    searchCriteria: ISummarySearchDTO,
} & BaseUseQueryParameters<ISummaryObjectsDTO | undefined>;

export function useObjectsWithoutSetpointsData({
    groupID,
    searchCriteria,
    enabled,    
    onSuccess,
    onError
}: UseObjectsWithoutSetpointsDataParams) {
    return useQuery<ISummaryObjectsDTO, RestError>(
        keys.objectsWithoutSetPoints(groupID, searchCriteria),
        ({ signal }) => {
            return SetpointAdministrationDataService.getObjectsWithoutSetpoints(
                groupID, 
                searchCriteria,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            refetchInterval: false,
            refetchOnMount: true
        }
    );
}